const features = [
  {
    icon: 'ri-4k-line',
    title: '高清画质',
    desc: '支持1080P与4K超高清播放，画面细腻流畅，带来影院级观影享受，告别模糊画质。',
  },
  {
    icon: 'ri-flashlight-line',
    title: '极速不缓冲',
    desc: '采用智能CDN加速技术，视频秒加载零等待，高清在线不缓冲，追剧更畅快。',
  },
  {
    icon: 'ri-stack-line',
    title: '海量片库',
    desc: '汇聚电影、电视剧、综艺、动漫、纪录片等10万+影视资源，每日持续更新扩充。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '多端同步',
    desc: '支持电脑、平板、手机全终端无缝切换，观影记录云端同步，走到哪看到哪。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '免费安全',
    desc: '全站资源免费观看，无需会员注册即可畅享。严格内容审核保障安全观影环境。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="relative py-16 md:py-24 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12 md:mb-16">
          <span className="inline-block px-4 py-1.5 rounded-full bg-primary-100/70 text-primary-700 text-xs font-semibold mb-4">
            为什么选择我们
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-3">
            平台优势
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            糖心视频致力于打造极致的免费观影体验，五大核心优势让你追剧无忧
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5 md:gap-6">
          {features.map((item) => (
            <div
              key={item.title}
              className="group bg-background-50 rounded-xl p-6 md:p-7 text-center hover:bg-primary-50/40 transition-colors duration-300 cursor-default"
            >
              <div className="w-14 h-14 mx-auto mb-4 flex items-center justify-center rounded-xl bg-primary-100/60 text-primary-600 group-hover:bg-primary-200/60 transition-colors duration-300">
                <i className={`${item.icon} text-2xl`}></i>
              </div>
              <h3 className="text-base md:text-lg font-heading font-bold text-foreground-900 mb-3">
                {item.title}
              </h3>
              <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}